export const SET_USERINFO = (state, userInfo) => {
  state.userInfo = userInfo
}
export const SET_NODES = (state, nodes) => {
  state.nodes = nodes
}
export const SET_NODEID = (state, nodeId) => {
  state.nodeId = nodeId
}
export const SET_NODE_NAVIGATION_CONTEXT = (state, {nodeId, context}) => {
  state.nodeNavigationContexts = {
    ...state.nodeNavigationContexts,
    [nodeId]: context,
  }
}
export const SET_NODE_NAVIGATION_STATUS = (state, {nodeId, status}) => {
  state.nodeNavigationStatus = {
    ...state.nodeNavigationStatus,
    [nodeId]: status,
  }
}
export const REMOVE_NODE_NAVIGATION_CONTEXTS = (state, nodeIds) => {
  const contexts = {...state.nodeNavigationContexts}
  const statuses = {...state.nodeNavigationStatus}
  nodeIds.forEach((nodeId) => {
    delete contexts[nodeId]
    delete statuses[nodeId]
  })
  state.nodeNavigationContexts = contexts
  state.nodeNavigationStatus = statuses
}
export const RESET_NODE_NAVIGATION = (state) => {
  state.nodeNavigationContexts = {}
  state.nodeNavigationStatus = {}
  state.nodeNavigationSequence = 0
  state.pendingNodeId = null
}
export const SET_NODE_NAVIGATION_SEQUENCE = (state, sequence) => {
  state.nodeNavigationSequence = sequence
}
export const SET_NAVIGATION_SESSION_GENERATION = (state, generation) => {
  state.navigationSessionGeneration = generation
}
export const SET_PENDING_NODE_ID = (state, nodeId) => {
  state.pendingNodeId = nodeId
}
export const SET_DEFAULT_NODE = (state, defaultNode) => {
  state.defaultNode = defaultNode
}
export const SET_INDUSTORY_TYPES = (state, industoryTypes) => {
  state.industoryTypes = industoryTypes
}
export const SET_ORGANIZATIONS = (state, organization) => {
  state.organization = organization
}
export const SET_USERROLES = (state, userRoles) => {
  state.userRoles = userRoles
}
export const SET_LOADED = (state, isLoaded) => {
  state.isLoaded = isLoaded
}

export const SET_COMMON_LOADED = (state, isCommonLoaded) => {
  state.isCommonLoaded = isCommonLoaded
}

export const SET_ROUTE_LOADED = (state, isRouteLoaded) => {
  state.isRouteLoaded = isRouteLoaded
}

export const SET_ROUTE_INIT_SCOPE = (state, routeInitScope) => {
  state.routeInitScope = routeInitScope
}

export const SET_API_CLIENT = (state, apiClient) => {
  state.apiClient = apiClient
}

export const SET_DISABLE = (state, isDisable) => {
  state.isDisable = isDisable
}
